import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Stack, Typography, Button, List, ListItem, ListItemText, ListItemIcon  } from '@mui/material';
import Iconify from 'src/components/iconify';
import CheckIcon from '@mui/icons-material/Check';

// Mock data
const mockUpdates = [
  {
    id: '1',
    version: '2.0.3',
    title: 'Versiyon 2.0.3 ile Gelen Yenilikler',
    shortDesc: 'Versiyon 2.0.3 ile gelen yenilikler ve düzeltmeler',
    longDesc: [
      'EP Hizmet Yönetimi sayfası güncellemeleri.',
      'Emanet Dolap admin sistemi güncellemeleri.'
    ],
    date: '25.11.2025',
  },
];

export default function UpdateReports() {
  const navigate = useNavigate();
  const { id } = useParams();

  // Eğer id varsa detay sayfası, yoksa liste sayfası gösterilecek
  if (id) {
    const update = mockUpdates.find((item) => item.id === id);
    if (!update) {
      return <Typography>Güncelleme notu bulunamadı.</Typography>;
    }
    return (
      <Stack sx={{ p: 4 }}>
        <Stack sx={{width: '100%', flexDirection : 'row' , justifyContent : 'space-between', mb: 4}}>
            <Typography variant="h5" sx={{color : '#111928', fontSize: '24px !important', lineHeight : '150%' }}>
            Güncelleme Notları
            </Typography>
            <Iconify onClick={() => navigate(-1)} style={{ color: '#98A2B3', width: 30, height: 30, cursor: 'pointer' }} icon="mdi:chevron-left" />
        </Stack>
        <Card sx={{ p: 3, mb: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
            <Stack>
              <Typography variant="body2" color="text.secondary">
                Güncelleme: {update.version}
              </Typography>
              <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1 }}>
                {update.title}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: '#6B7280', fontSize: 14 }}>
                {Array.isArray(update.longDesc) ? (
                  <List sx={{ paddingLeft: 2, paddingTop: 0, paddingBottom: 0 }}>
                    {update.longDesc.map((item, index) => (
                      <ListItem key={index} disableGutters sx={{ paddingBottom: '4px', alignItems: 'center' }}>
                        <ListItemIcon sx={{ minWidth: 20, mt: '3px', color: '#10B981' }}>
                          <CheckIcon sx={{ fontSize: 16 }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography variant="body2" sx={{ color: '#6B7280', fontSize: 14 }}>
                              {item}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  update.longDesc
                )}
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {update.date}
            </Typography>
          </Stack>
        </Card>
      </Stack>
    );
  }

  // Liste sayfası
  return (
    <Stack sx={{ p: 4 }}>
      <Typography variant="h5" sx={{ mb: 4, color : '#111928', fontSize: '24px !important', lineHeight : '150%' }}>
        Güncelleme Notları
      </Typography>
      {mockUpdates.map((update) => (
        <Card key={update.id} sx={{ p: 3, mb: 2, boxShadow: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
            <Stack>
              <Typography variant="body2" color="text.secondary">
                Güncelleme: {update.version}
              </Typography>
              <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1 }}>
                {update.title}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color:'#6B7280', }}>
                {update.shortDesc}
              </Typography>
              <Typography
                variant="text"
                sx={{ color: '#DB3831', mt: 1, p: 0, minWidth: 0, cursor: "pointer" }}
                onClick={() => navigate(`/dashboard/update-reports/${update.id}`)}
              >
                Tamamını Oku
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {update.date}
            </Typography>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}